import React from 'react';
import { atom } from "recoil";
import { AlertCircle as AlertCircleIcon } from "react-feather";

const siteState = atom({
  key: 'siteState',
  default: 'https://www.hangeulu.kr/'
});
const itemState = atom({
  key: 'itemState',
  default: []
});
const argState = atom({
  key: 'argState',
  default: []
});
const catState = atom({
  key: 'catState',
  default: [
    {
      href: '/404',
      icon: AlertCircleIcon,
      title: 'Category',
      status: false
    }
  ]
});
// const catsState = selector({
//   key: 'catsState', // unique ID (with respect to other atoms/selectors)
//   get: ({ get }) => {
//     const result = get(catState);
//
//     return result;
//   },
// });

const pageNumState = atom({
  key: 'pageNumState',
  default: 12
});
const pageState = atom({
  key: 'pageState',
  default: 1
});

export {
  siteState,
  itemState,
  argState,
  pageState,
  pageNumState,
  catState
};
